export interface SpecialItem {
  id: string;
  type: 'special';
  title: string;
  summary: string;
  cover: string;
  author: string;
  publishedAt: string;
  category: string;
  tags: string[];
  views: number;
  relatedIds: string[];
  body: string[];
}

export const specialList: SpecialItem[] = [
  {
    id: 'special-01',
    type: 'special',
    title: '盛夏影视季：一整季的片单指南',
    summary: '把整个夏天值得一看的剧集与电影打包整理，按心情分类，随手挑一部就能开始。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20summer%20film%20season%20banner%20with%20sun%20and%20popcorn%20and%20tickets%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=special-cover-01&orientation=landscape',
    author: '一起艹编辑部',
    publishedAt: '2026-10-12',
    category: '专题',
    tags: ['影视', '片单', '合集'],
    views: 89200,
    relatedIds: ['news-01', 'news-03', 'news-07', 'news-09'],
    body: [
      '这个专题把我们整个夏天看过、聊过的影视内容整理成了一份片单。',
      '按照「想看爽的」「想看静的」「想看暖的」三个方向分类，你可以根据当时的心情快速选择。',
      '专题会持续更新，欢迎收藏后随时回来看看有没有新的推荐。',
    ],
  },
  {
    id: 'special-02',
    type: 'special',
    title: '音乐现场盘点：从Livehouse到体育场',
    summary: '不同规模的现场，带来完全不同的体验。这一期聊聊声音、空间与人的关系。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20music%20venue%20scale%20from%20small%20club%20to%20big%20stadium%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=special-cover-02&orientation=landscape',
    author: '声音现场',
    publishedAt: '2026-10-11',
    category: '专题',
    tags: ['活动', '音乐', '现场'],
    views: 64300,
    relatedIds: ['news-02', 'news-05', 'video-01', 'video-06'],
    body: [
      '从几十人的小场地，到几万人的体育场，现场演出构建了完全不同的情绪场。',
      '这个专题分别走访了三种规模的现场，记录声音、灯光与观众之间微妙的互动。',
      '如果你也常去看演出，或许能在这里找到共鸣。',
    ],
  },
  {
    id: 'special-03',
    type: 'special',
    title: '年度话题回顾：我们这一年都在讨论什么',
    summary: '把过去一年社区里最热闹的讨论重新梳理，看看大家真正关心的是什么。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20a%20year%20timeline%20with%20speech%20bubbles%20and%20stars%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=special-cover-03&orientation=landscape',
    author: '一起艹话题组',
    publishedAt: '2026-10-10',
    category: '专题',
    tags: ['话题', '盘点', '社区'],
    views: 52300,
    relatedIds: ['topic-01', 'topic-02', 'topic-04', 'topic-06'],
    body: [
      '这一年里，社区里出现了很多有意思的讨论。',
      '我们按主题把它们重新整理，有关于作品的争论，也有纯粹的情感分享。',
      '希望这份回顾，能让新朋友快速了解这里的氛围。',
    ],
  },
  {
    id: 'special-04',
    type: 'special',
    title: '新锐创作者图鉴：值得关注的十个人',
    summary: '他们或许还没有很高的知名度，但作品里有着难得的真诚与勇气。',
    cover: 'https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20creative%20tools%20like%20camera%20guitar%20and%20paintbrush%20arranged%20together%2C%20vibrant%20orange%20and%20deep%20gray-blue%20palette%2C%20soft%20gradient%20background%2C%20modern%20minimalist%2C%20no%20text&width=800&height=450&seq=special-cover-04&orientation=landscape',
    author: '一起艹编辑部',
    publishedAt: '2026-10-09',
    category: '专题',
    tags: ['人物', '创作', '图鉴'],
    views: 47800,
    relatedIds: ['video-06', 'video-07', 'news-06', 'news-08'],
    body: [
      '在流量之外，还有一群创作者在安静地打磨自己的作品。',
      '这个专题收录了十位新锐创作者，他们来自动画、音乐、短片等不同领域。',
      '如果你也被他们的真诚打动，欢迎去关注他们的作品。',
    ],
  },
];